( function( $ ) {

    /*AOS init*/
    $(window).on("load",function(){
        AOS.init();
    });
    /*AOS init*/

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/
 
    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header menu*/
    $('.js-hMenuBtn').click(function(){
        $(this).toggleClass('active');
        $('.js-hMenu').slideToggle();
        $('.js-header').toggleClass('opened');
    });


    $('.js-hMenu').click(function(e) {
        e.stopPropagation();
    });
    $('.js-hMenu ul li a').click(function(e) {
        if ($(window).width() < 992) {
            $('.js-hMenuBtn').removeClass('active');
            $('.js-hMenu').slideUp();
        }
    });

    $(document).ready(function () {
        const header = $('.js-header')[0];

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const section = $(entry.target);
                    const color = section.data('hcolor');

                    header.className = 'header js-header';

                    if (color) {
                        header.classList.add(color);
                    }
                }
            });
        }, {
            root: null,
            threshold: 0.1
        });

        $('[data-hcolor]').each(function () {
            observer.observe(this);
        });
    });

    $(document).on("mouseover", "[data-menu-item-id]", function() {
        if ($(window).width() >= 992) {
            if (!$(this).hasClass("active") && !$(this).closest('[data-menu-item-id]').hasClass("active")) {
                $(this).closest('.sub-menu-row').find('[data-menu-item-id]').removeClass("active");
                $(this).closest('.sub-menu-row').find('[data-menu-sub-id]').removeClass("active");
                $(this).closest('.sub-menu-row').find('[data-menu-item-id="'+$(this).data('menu-item-id')+'"]').addClass("active");
                $(this).closest('.sub-menu-row').find('[data-menu-sub-id="'+$(this).data('menu-item-id')+'"]').addClass("active");
            }
        }
    });
    $(document).on("mouseover", "[data-menu-thumb-id]", function() {
        if ($(window).width() >= 992) {
            if ($(this).data('menu-thumb-id') === undefined || $(this).data('menu-thumb-id') === null || $(this).data('menu-thumb-id') === '') {
                $(this).closest('.sub-menu-row').find('.js-subMenuColsImg').css({'display' : 'none'}).removeAttr("src").attr("alt", '');
            } else {
                $(this).closest('.sub-menu-row').find('.js-subMenuColsImg').css({'display' : 'block'}).attr("src", $(this).data('menu-thumb-id')).attr("alt", $(this).data('menu-thumb-alt') || '');
            }
        }
    });

    $('.js-hMenuArr').click(function(e) {
        $(this).toggleClass('clicked');
        $(this).siblings('.sub-menu').slideToggle()
    });
    /*header menu*/

    /*video*/
    $(document).ready(function () {
        if ($('#vimeo-player').length > 0) {
            var video = $('#vimeo-player')[0];
            video.muted = true;

            function toggleSound(_this) {
                _this.find('.sound').removeClass('active');
                if (video.muted) {
                    video.muted = false;
                    if (video.volume === 0) {
                        video.volume = 1;
                    }
                    var playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise.catch(function () {});
                    }
                    _this.find('.sound[data-sound="enabled"]').addClass('active');
                } else {
                    video.muted = true;
                    _this.find('.sound[data-sound="disabled"]').addClass('active');
                }
            }

            $('.js-firstLoud').on('click', function () {
                toggleSound($(this));
            });
        }
    });
    /*video*/

    /*main gal*/
    $(document).ready(function() {
        if ($(window).width() > 991) {
            if ($('.js-mainGal').length > 0) {
                var duplications = $('.js-mainGal').data('duplications');
                $('.js-mainGal').each(function (i) {
                    $(this).marquee({
                        startVisible: true,
                        duration: 25000,
                        gap: 0,
                        delayBeforeStart: 0,
                        direction: 'left',
                        duplicated: true,
                        duplicateCount: duplications
                    });
                });
            }
        }
        if ($(window).width() <= 991) {
            $('.js-mainGalSlider').on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
                var cnt = slick.options.slidesToScroll;
                var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
                $('.js-mainGalSliderCounter').html(
                    '<span>' + slideNum + '</span><span class="sep"> — </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
                );
                if ((Math.ceil(slick.slideCount / cnt)) === 1) {
                    $('.js-mainGalSliderCounter').hide();
                } else {
                    $('.js-mainGalSliderCounter').show();
                }
            });
            $('.js-mainGalSlider').slick({
                arrows: true,
                centerMode: false,
                slidesToShow: 1,
                appendArrows: $('.js-mainGalSliderArrows'),
                prevArrow: '<button class="arrow prev-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.8134 0.5L0.499687 11.8137M0.499687 11.8137L11.8134 23.1274M0.499687 11.8137H21.7129" stroke="#6B5E55" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
                nextArrow: '<button class="arrow next-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.3995 0.5L21.7132 11.8137M21.7132 11.8137L10.3995 23.1274M21.7132 11.8137H0.5" stroke="#6B5E55" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>'
            });
        }
    });

    $('.js-mainGalModalSlider').slick({
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
        prevArrow: '<button class="arrow prev-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.8134 0.5L0.499687 11.8137M0.499687 11.8137L11.8134 23.1274M0.499687 11.8137H21.7129" stroke="#6B5E55" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.3995 0.5L21.7132 11.8137M21.7132 11.8137L10.3995 23.1274M21.7132 11.8137H0.5" stroke="#6B5E55" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>'
    });

    $('.js-mainGalSlide').click(function(e){
        e.preventDefault();
        var slide = $(this).data('mslide');
        $('.js-mainGalModalSlider').slick('slickGoTo', slide, true);
        $('.js-mainGalModal').addClass('active');
    })
    $('.js-mainGalModalCls').click(function(){
        $('.js-mainGalModal').removeClass('active');
    });
    /*main gal*/

    /*main parc*/
    $('.js-mainParcImgHov').on('mouseover', function(){
        $('.js-mainParcImg').removeClass('active');
        $('.js-mainParcImg[data-img="'+$(this).data('img')+'"]').addClass('active');
    })
    /*main parc*/

    /*main cons*/
    $(document).on("mouseover", ".js-mainConsBl", function() {
        if ($(window).width() >= 992) {
            if (!$(this).hasClass("active") && !$(this).closest('.js-mainConsBl').hasClass("active")) {
                $('.js-mainConsBl').removeClass("active");
                $('.js-mainConsImg').stop(true, true).fadeOut(250);
                $('.js-mainConsBl[data-img="'+$(this).data('img')+'"]').addClass("active");
                $('.js-mainConsImg[data-img="'+$(this).data('img')+'"]').addClass("active");
                $('.js-mainConsImg[data-img="'+$(this).data('img')+'"]').stop(true, true).fadeIn(250);
            }
        }
    });
    /*main cons*/

    /*simple parallax*/
    $(window).on('load resize', function(){
        var image = document.getElementsByClassName('js-parallax');
        new simpleParallax(image);
    });

    $(window).on('load resize', function(){
        if ($(window).width() > 767) {
            var image = document.getElementsByClassName('js-parallaxMain');
            new simpleParallax(image);
        }
    });
    /*simple parallax*/

    /*parallax scroll*/
    // init controller
    $(document).ready(function(){
        if ($(window).width() > 767) {
            var windowHeight = $(window).height();
            const pCabSMController = new ScrollMagic.Controller,
                pCabValListClass = ".js-mainParalScrollList",
                pCabValListItem1Class = ".js-mainParalScrollList .js-mainParalScrollListItem:nth-child(1)",
                pCabValListItem2Class = ".js-mainParalScrollList .js-mainParalScrollListItem:nth-child(2)";

            const trigHook = 1;

            var anim = (new TimelineMax).from($(pCabValListItem1Class), .01, {
                y: "155px",
                ease: Linear.easeNone
            }).to($(pCabValListItem1Class), .01, {
                y: "-155px",
                ease: Linear.easeNone
            });
            new ScrollMagic.Scene({
                triggerElement: pCabValListItem1Class,
                duration: windowHeight
            }).setTween(anim).triggerHook(trigHook).addTo(pCabSMController);

            var anim = (new TimelineMax).from($(pCabValListItem2Class), .01, {
                y: "100px",
                ease: Linear.easeNone
            }).to($(pCabValListItem2Class), .01, {
                y: "-100px",
                ease: Linear.easeNone
            });
            new ScrollMagic.Scene({
                triggerElement: pCabValListItem2Class,
                duration: windowHeight
            }).setTween(anim).triggerHook(trigHook).addTo(pCabSMController);
        }
    });
    /*parallax scroll*/


    /*main cons*/
    $(document).on("mouseover", ".js-taxTraitPostsBl", function() {
        if ($(window).width() >= 992) {
            if (!$(this).hasClass("active") && !$(this).closest('.js-taxTraitPostsBl').hasClass("active")) {
                $('.js-taxTraitPostsBl').removeClass("active");
                $('.js-taxTraitPostsImg').removeClass("active");
                $('.js-taxTraitPostsImg').stop(true, true).fadeOut(250);
                $('.js-taxTraitPostsBl[data-img="'+$(this).data('img')+'"]').addClass("active");
                $('.js-taxTraitPostsImg[data-img="'+$(this).data('img')+'"]').addClass("active");
                $('.js-taxTraitPostsImg[data-img="'+$(this).data('img')+'"]').stop(true, true).fadeIn(250);
            }
        }
    });
    /*main cons*/

    /*page conseils slider*/

    $('.js-pageConsFaqTab').click(function(){
        var dataId = $(this).data('id');
        $('.js-pageConsFaqTab').removeClass('active');
        $('.js-pageConsFaqTabCont').removeClass('active')
        $('.js-pageConsFaqSliderArr').removeClass('active')
        $('.js-pageConsFaqSliderArrMob').removeClass('active')
        $(this).addClass('active');
        $('.js-pageConsFaqTabCont[data-id="'+dataId+'"]').addClass('active');
        $('.js-pageConsFaqSliderArr[data-id="'+dataId+'"]').addClass('active');
        $('.js-pageConsFaqSliderArrMob[data-id="'+dataId+'"]').addClass('active');
    });

    $('.js-pageConsFaqTabSlider').each(function(){
        var dataId = $(this).closest('.js-pageConsFaqTabCont').data('id');
        $(this).slick({
            arrows: true,
            centerMode: false,
            slidesToShow: 1,
            prevArrow: '<button class="arrow prev-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.8134 0.5L0.499687 11.8137M0.499687 11.8137L11.8134 23.1274M0.499687 11.8137H21.7129" stroke="white" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            nextArrow: '<button class="arrow next-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.3995 0.5L21.7132 11.8137M21.7132 11.8137L10.3995 23.1274M21.7132 11.8137H0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
            appendArrows: $('.js-pageConsFaqSliderArr[data-id="' + dataId + '"]'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        appendArrows: $('.js-pageConsFaqSliderArrMob[data-id="' + dataId + '"]'),
                    }
                }
            ]
        });
    });

    // video

    $('.js-pageConsVidsSlider').slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        appendArrows: $('.js-pageConsVidsSliderArrs'),
        prevArrow: '<button class="arrow prev-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.8134 0.5L0.499687 11.8137M0.499687 11.8137L11.8134 23.1274M0.499687 11.8137H21.7129" stroke="#231F20" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.3995 0.5L21.7132 11.8137M21.7132 11.8137L10.3995 23.1274M21.7132 11.8137H0.5" stroke="#231F20" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    appendArrows: $('.js-pageConsVidsSliderArrsMob'),
                    slidesToShow: 1
                }
            }
        ]
    } );

    $('.js-pageConsVidsBl').each(function(){
        let $el = $(this);
        let type = $el.data('type');
        let videoId = $el.data('video');
        let img = $el.find('.js-pageConsVidsBlImg');

        // Thumbnail is rendered server-side; fetch only when PHP fell back to the placeholder
        if (!videoId || (img.attr('src') || '').indexOf('data:') !== 0) return;

        /* VIMEO */
        if (type === 'vimeo') {
            $.getJSON('https://vimeo.com/api/oembed.json', {
                url: 'https://vimeo.com/' + videoId
            }, function (data) {
                let thumbUrl = data.thumbnail_url.replace(/-d_\d+x\d+\?/, '-d_640?');
                img.attr('src', thumbUrl);
            });
        }

        /* YOUTUBE */
        if (type === 'youtube') {
            img.attr(
                'src',
                'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg'
            );
        }
    })
    $('.js-pageConsVidsBl').click(function(){
        let type = $(this).data('type');
        let videoId = $(this).data('video');
        let iframeSrc = '';

        if (type === 'vimeo') {
            iframeSrc = 'https://player.vimeo.com/video/' + videoId +
                '?autoplay=1&loop=0&autopause=0&muted=0';
        }

        if (type === 'youtube') {
            iframeSrc = 'https://www.youtube.com/embed/' + videoId +
                '?autoplay=1&rel=0&showinfo=0';
        }

        var iframe = $('<iframe>', {
            src: iframeSrc,
            width: 1600,
            height: 900,
            frameborder: 0,
            allow: 'autoplay; fullscreen',
            allowfullscreen: true
        });
        $('.js-pageConsModalVid').append(iframe);
        $('.js-pageConsModal').addClass('active');
    })
    $('.js-pageConsModalCls').click(function(){
        $('.js-pageConsModal').removeClass('active');
        $('.js-pageConsModalVid').html('');
    });
    /*page conseils slider*/

    /*page cabinet mob slider*/
    var pageCabinetMobSlidersInited = false;
    $(window).on('load resize', function(){
        $('.js-pageCabinetMobSlider').each(function(){
            if ($(window).width() > 991 && pageCabinetMobSlidersInited) {
                $(this).slick('unslick');
            } else if ($(window).width() < 991) {
                $(this).slick({
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 2,
                    prevArrow: '<button class="arrow prev-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.8134 0.5L0.499687 11.8137M0.499687 11.8137L11.8134 23.1274M0.499687 11.8137H21.7129" stroke="#6B5E55" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
                    nextArrow: '<button class="arrow next-arrow"><svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.3995 0.5L21.7132 11.8137M21.7132 11.8137L10.3995 23.1274M21.7132 11.8137H0.5" stroke="#6B5E55" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>'
                });
            }
        });
        if ($(window).width() > 991) {
            pageCabinetMobSlidersInited = false;
        } else {
            pageCabinetMobSlidersInited = true
        }
    })
    /*page cabinet mob slider*/

    /*page cabinet tech*/
    $(document).on("mouseover", ".js-pageCabinetTechItem", function() {
        if ($(window).width() >= 992) {
            if (!$(this).hasClass("active") && !$(this).closest('.js-pageCabinetTechItem').hasClass("active")) {
                $('.js-pageCabinetTechItem').removeClass("active");
                $('.js-pageCabinetTechBg').removeClass("active");
                $('.js-pageCabinetTechBg[data-item="'+$(this).data('item')+'"]').addClass("active");
                $('.js-mainCabinetTechImg[data-item="'+$(this).data('item')+'"]').addClass("active");
            }
        }
    });
    /*page cabinet tech*/

}( jQuery ) );
